<template>
  <div class="photo-gallery">
    <div v-if="photos.length === 0" class="empty-state">
      <p> <span class="mdi mdi-camera-off-outline"></span></p>
    </div>

    <div v-else class="photo-grid">
      <div
          v-for="photo in displayedPhotos"
          :key="photo.id"
          class="photo-item">
        <img
            :src="photo.url"
            :alt="photo.name"
            class="photo-img"
        >

        <div class="photo-overlay">
          <div v-if="photo.originalData" class="photo-details">
            <small>{{ photo.originalData.nom_source }}</small>
          </div>
        </div>
      </div>
    </div>
    <span class="help" v-if="displayedPhotos.length > 0">{{ $t('socialMedia.photosLimitInfoAllRs') }}</span>
  </div>
</template>

<script>
export default {
  name: 'PhotoGallery',
  props: {
    photos: {
      type: Array,
      required: true,
      default: () => []
    },
    title: {
      type: String,
      default: 'Galerie Photos'
    },
    emptyMessage: {
      type: String,
      default: 'Aucune photo dans la galerie'
    }
  },
  computed: {
    displayedPhotos() {
      return this.photos.slice(0, 10);
    }
  }
}
</script>

<style lang="css" scoped>
.photo-gallery {
  width: 100%;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.photo-item {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  background: #f9fafb;
}

.photo-item:hover {
  transform: translateY(-4px);
}

.photo-img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.photo-item:hover .photo-img {
  transform: scale(1.05);
}

.photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.7) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 16px;
}

.photo-item:hover .photo-overlay {
  opacity: 1;
}

.photo-details {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
}

.empty-state {
  text-align: center;
  font-size: 80px;
  color: #1A4A56;
}

@media (max-width: 768px) {
  .photo-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}
</style>
